import {
  getPageResumeQuery,
  getPagePreviewResumeQuery,
  cache,
} from '@redlink/services';

export const freshCacheForRemoveItem =
  ({ pageName }) =>
  (
    cache,
    {
      data: {
        RemoveResumeItem: { id, type },
      },
    }
  ) => {
    freshLinksRemove({ cache, id, type });
    freshPreviewLinksRemove({ cache, id, pageName, type });
  };

const freshLinksRemove = ({ cache, id, type }) => {
  let { Resume } = cache.readQuery({
    query: getPageResumeQuery,
  });

  const oldData = Resume[`${type}s`];

  cache.writeQuery({
    query: getPageResumeQuery,
    data: {
      Resume: {
        ...Resume,
        [`${type}s`]: [...oldData.filter((p) => p.id !== id)],
      },
    },
  });
};

const freshPreviewLinksRemove = ({ cache, id, pageName, type }) => {
  try {
    let { ResumePreview } = cache.readQuery({
      query: getPagePreviewResumeQuery,
      variables: { pageName },
    });

    const oldData = ResumePreview[`${type}s`];

    cache.writeQuery({
      query: getPagePreviewResumeQuery,
      data: {
        ResumePreview: {
          ...ResumePreview,
          [`${type}s`]: [...oldData.filter((p) => p.id !== id)],
        },
      },
      variables: { pageName },
    });
  } catch (e) {}
};

export const freshCacheForVisibility =
  () =>
  (
    cache,
    { data: { SetResumeItemIsVisible: { id, isVisible, type } = {} } }
  ) => {
    freshLinksVisibility({ cache, isVisible, id, type });
  };

const freshLinksVisibility = ({ cache, isVisible, id, type }) => {
  let { Resume } = cache.readQuery({
    query: getPageResumeQuery,
  });

  const oldData = Resume[`${type}s`];
  let freshData = { ...oldData.find((p) => p.id === id), isVisible };

  cache.writeQuery({
    query: getPageResumeQuery,
    data: {
      Resume: {
        ...Resume,
        [`${type}s`]: getFreshLinks({ id, oldData, freshData }),
      },
    },
  });
};

const getFreshLinks = ({ id, oldData, freshData }) => {
  const editedItemIndex = oldData.findIndex((p) => p.id === id);
  return [
    ...oldData.slice(0, editedItemIndex),
    freshData,
    ...oldData.slice(editedItemIndex + 1),
  ];
};

export const freshCacheJobStatus =
  ({ pageName }) =>
  (cache, { data }) => {
    try {
      let {
        ResumePreview: { contacts, ...rest },
      } = cache.readQuery({
        query: getPagePreviewResumeQuery,
        variables: { pageName },
      });

      cache.writeQuery({
        query: getPagePreviewResumeQuery,
        data: {
          ResumePreview: {
            contacts: {
              jobStatus: data.SetPageJobStatus.value,
            },
            ...rest,
          },
        },
        variables: { pageName },
      });
    } catch (e) {}
  };

export const freshCacheForReoderItem = ({ oldIndex, newIndex, type }) => {
  let {
    Resume: { [`${type}s`]: oldData, ...rest },
  } = cache.readQuery({
    query: getPageResumeQuery,
  });

  const result = [...oldData];
  const [removed] = result.splice(oldIndex, 1);
  result.splice(newIndex, 0, removed);

  cache.writeQuery({
    query: getPageResumeQuery,
    data: {
      Resume: {
        ...rest,
        [`${type}s`]: result,
      },
    },
  });
};
